import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManagePackage/tab/General/PriceDuration/Views/price-duration.html';
import GeneralModule from '@/Pages/Admin/Modules/ManagePackage/Store/General';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {TrekPriceDurationModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/PriceDuration/TrekPriceDurationModel';


@WithRender
@Component({
    components: {
        'validation-error': ValidationError,
    }
})
export default class PriceDuration extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                    seasonsList: false,
                    getPriceDurationData: false,
                },
                postLoading: {
                    create: false,
                },
                canEdit: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
        };

        this.item = {
            priceDurationData: new TrekPriceDurationModel({}),
            tempPriceDurationData: new TrekPriceDurationModel({}),
        };
    }

    public mounted() {
        this.getAllSeasons();
        this.getPriceDuration();
    }

    get getSeasons() {
        return GeneralModule.Seasons;
    }

    public getAllSeasons() {
        this.ui.status.isLoading.seasonsList = true;
        GeneralModule.GetSeasons()
            .then((res: any) => {
            })
            .catch((error: any) => {
                this.ui.error.errors = error;
            })
            .finally(() => {
                this.ui.status.isLoading.seasonsList = false;
            });
    }


    public getPriceDuration() {
        this.ui.status.isLoading.getPriceDurationData = true;
        let data = {
            trek_id: this.$route.query.id
        };
        trekService
            .getPriceDuration(data)
            .then((res: any) => {
                res.data.data.trek_seasons = this.generateSeasonData(res.data.data);
                this.item.priceDurationData = res.data.data;
            })
            .catch((error: any) => {
                this.ui.error.errors = error;
            })
            .finally(() => {
                this.ui.status.isLoading.getPriceDurationData = false;
            });
    }

    protected addPriceDuration() {
        this.resetError();
        if (!this.validateAddPriceDurationAction()) {
            return;
        }
        const array: Array<number> = [];
        const arraySeasons: any = this.item.priceDurationData.trek_seasons;
        arraySeasons.forEach((item: any) => {
            array.push(item.id);
        });

        let data = {
            trek_id: Number(this.$route.query.id),
            seasons: array,
            min_people: Number(this.item.priceDurationData.min_people),
            max_people: Number(this.item.priceDurationData.max_people),
            min_age: Number(this.item.priceDurationData.min_age),
            max_age: Number(this.item.priceDurationData.max_age),
            duration_nights: Number(this.item.priceDurationData.duration_nights),
            duration_days: Number(this.item.priceDurationData.duration_days)
        };
        this.ui.status.postLoading.create = true;
        trekService
            .editPrice(data)
            .then((res: any) => {
                res.data.data.trek_seasons = this.generateSeasonData(res.data.data);
                this.item.priceDurationData = res.data.data;
                this.ui.status.canEdit = false;
                flashService.Success('Price Duration Saved', res.data.message);
                this.resetError();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then((res: any) => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.create = false;
            });
    }

    protected validateAddPriceDurationAction() {
        let list = this.item.priceDurationData;
        if (!list.min_age || !list.max_age) {
            if (!list.min_age) {
                Object.assign(this.ui.error.errors, {
                    min_age: ['The min age field is required.']
                });
            }
            if (!list.max_age) {
                Object.assign(this.ui.error.errors, {
                    max_age: ['The max age field is required.']
                });
            }
        } else {
            if (list.min_age >= list.max_age) {
                Object.assign(this.ui.error.errors, {
                    max_age: [`The maximum age must be greater than minimum age.`]
                });
            }
        }
        if (!list.min_people || !list.max_people) {
            if (!list.min_people) {
                Object.assign(this.ui.error.errors, {
                    min_people: ['The min people field is required.']
                });
            }
            if (!list.max_people) {
                Object.assign(this.ui.error.errors, {
                    max_people: ['The max people field is required.']
                });
            }
        } else {
            if (list.min_people >= list.max_people) {
                Object.assign(this.ui.error.errors, {
                    max_people: [`The max people must be greater than minimum people.`]
                });
            }
        }
        if (list.duration_nights && list.duration_days) {
            if (list.duration_nights >= list.duration_days) {
                Object.assign(this.ui.error.errors, {
                    max_days: [`The day must be greater than specified night.`]
                });
            }
        }

        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    protected editPriceDuration() {
        this.item.tempPriceDurationData = Object.assign({}, this.item.priceDurationData);
        this.ui.status.canEdit = true;
    }

    protected cancelPriceDuration() {
        this.resetError();
        this.ui.status.canEdit = false;
        this.item.priceDurationData = this.item.tempPriceDurationData;
    }

    public preventNonNumericalInput(event: any) {
        common.preventNonNumericalInput(event);
    }

    public get buttonName() {
        if (this.ui.status.postLoading.create) {
            return 'Processing...';
        }
        return 'Save';
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }

    public generateSeasonData(list: any) {
        let array: Array<number> = [];
        Object.values(list.trek_seasons).forEach((item: any) => {
            array.push(item.seasons);
        });
        return array;
    }
}
